import React, {Component} from 'react';
import rightCenterIcon from "../../../components/image/rightCenter.png";

class FloatRightTool extends Component {

    onClick = ()=>{
        this.props.editor.execCommand("imagefloat", "right");
    };

    getName = () => {
        return "floatRightTool"
    }

    render() {
        return (
            <span>
                <img src={rightCenterIcon} onClick={()=>{this.onClick()}}/>
            </span>
        );
    }
}

export default FloatRightTool;